import React, { useState, useEffect, useRef } from "react";
import Header from "../../layouts/Header";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Row,
  Image,
  Badge,
  Modal,
  Spinner,
  Form,
  Table,
} from "react-bootstrap";
import {
  EyeFill,
  EyeSlashFill,
  PencilFill,
  TrashFill,
  ViewList,
  ViewStacked,
} from "react-bootstrap-icons";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { TagsInput } from "react-tag-input-component";
import ReactToPrint from 'react-to-print';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MenuCatalog = () => {

  const navigate = useNavigate();
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [menuAccess, setMenuAccess] = useState([]);

  console.log("Access :", access);
  console.log("Email :", email);


  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("MenuCatalog:")
      );
      setMenuAccess(filteredAccess);
    }
  }, [access]);

  console.log("Menu Access:", menuAccess);

  const accessToken = localStorage.getItem("authToken");
  const printRef = useRef();
  const [productsList, setProductsList] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productLoading, setProductLoading] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openEditImageModal, setOpenEditImageModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [imageId, setImageId] = useState("");
  const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
  const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [imageError, setImageError] = useState('');
  const [displayImage, setDisplayImage] = useState({});
  const [productId, setProductId] = useState('');
  const [editedData, setEditedData] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editedSelectedExOutlets, setEditedSelectedExOutlets] = useState([]);
  const [productDetails, setProductDetails] = useState({});
  const [productTags, setProductTags] = useState([]);
  const [productTagsList, setProductTagsList] = useState([]);
  const [tagText, setTagText] = useState("");
  const [outlets, setOutlets] = useState([]);
  const animatedComponents = makeAnimated();
  const [foodTypeFilter, setFoodTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [orderTypeFilter, setOrderTypeFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [productTagFilter, setProductTagFilter] = useState("all");
  const [searchText, setSearchText] = useState('');
  const [showEditCoverModal, setShowEditCoverModal] = useState(false);
  const [selectedNature, setSelectedNature] = useState([]);
  const [isCoverImageLoading, setIsCoverImageLoading] = useState(false);
  const [coverImage, setCoverImage] = useState(null);

  const menuItems = [
    {
      title: "Kung Pao Tofu Recipe",
      image: "/images/menu1.jpg", // Replace with actual image paths
      category: "Food/Noodle",
    },
    {
      title: "Pan Seared Salmon",
      image: "/images/menu2.jpg",
      category: "Food/Noodle",
    },
    {
      title: "Dal Palak Recipe",
      image: "/images/menu3.jpg",
      category: "Food/Noodle",
    },
    // Add more menu items as needed
  ];

  const outletData = outlets.map((outlet) => ({
    value: outlet._id,
    label: `${outlet.name} (${outlet.city})${outlet.status === "COMING_SOON" || outlet.status === "INACTIVE"
        ? ` - ${outlet.status.replace("_", " ")}`
        : ""
      }`,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "6px",
      minWidth: "200px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
  };

  const getOutlets = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("outlet", { headers });

      if (response?.data?.status === true) {

        // let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");

        setOutlets(response?.data?.data?.outlets);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getProductsList = async (category, productTag, newStatus, foodType, orderType) => {
    setProductLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const params = [];

      if (category !== "all" && category) {
        params.push(`category=${category}`);
      }

      if (productTag !== "all") {
        params.push(`productTag=${productTag}`);
      }

      if (newStatus !== "all") {
        params.push(`status=${newStatus}`);
      }

      if (foodType !== "all") {
        params.push(`foodType=${foodType}`);
      }

      if (orderType) {
        params.push(`orderType=${orderType}`);
      }

      const queryString = params.length > 0 ? `?${params.join('&')}` : '';
      const newUrl = `product${queryString}`;

      const response = await axios.get(newUrl, { headers });
      if (response?.data?.status === true) {
        const products = response?.data?.data?.products;
        console.log("Products :", products);

        setProductsList(products);
        setFilteredProducts(products);

      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setProductLoading(false);
    }
  };

  const getCategoryList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("masters/category/get", { headers });

      if (response?.data?.status === true) {
        setCategoryList(response?.data?.data?.categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getSingleProductDetails = async (productId) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get(`product?_id=${productId}`, { headers });
      if (response?.data?.status === true) {
        setProductDetails(response?.data?.data?.products);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const handleCategoryFilter = (e) => {
    const value = e.target.value;
    setCategoryFilter(value);
    getProductsList(value, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter);
    // applyAllFilters(foodTypeFilter, statusFilter, value, productTagFilter);
  };

  const handleProductTagFilter = (e) => {
    const value = e.target.value;
    setProductTagFilter(value);
    getProductsList(categoryFilter, value, statusFilter, foodTypeFilter, orderTypeFilter);
  };

  const handleFoodTypeFilter = (e) => {
    const value = e.target.value;
    setFoodTypeFilter(value);
    getProductsList(categoryFilter, productTagFilter, statusFilter, value, orderTypeFilter);
  };

  const handleStatusFilter = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    getProductsList(categoryFilter, productTagFilter, value, foodTypeFilter, orderTypeFilter);
  };

  const handleOrderTypeFilter = (e) => {
    const value = e.target.value;
    setOrderTypeFilter(value);
    getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, value);
  }

  const applyAllFilters = (foodType, status, category, productTag) => {

    let filteredData = productsList;

    // Apply food type filter
    if (foodType !== "all") {
      filteredData = filteredData.filter((item) => item.foodType === foodType);
    }

    // Apply status filter
    if (status !== "all") {
      filteredData = filteredData.filter((item) => item.status === status);
    }

    // Apply category filter
    if (category !== "all") {
      filteredData = filteredData.filter((item) => item.category?._id === category);
    }

    // Apply product tag filter
    if (productTag !== "all") {
      filteredData = filteredData.filter((item) => item.productTag && item.productTag._id === productTag);
    }

    // Apply status filter
    // if (orderType !== "") {
    //   filteredData = filteredData.filter((item) => item.orderType === orderType);
    // }

    // Update the filtered products state
    setFilteredProducts(filteredData);
  };

  const handleSearchText = (e) => {
    setTagText(e.target.value)
    setEditedData((prev) => ({ ...prev, productTagName: e.target.value, productTagId: null }))
  }

  const getProductTags = async (text) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get(`/product/tags?search=${text}`, { headers });

      if (response?.data?.status === true) {
        setProductTags(response?.data?.data?.productTags);
      } else {
        setProductTags([])
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getProductTagsList = async (text) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get(`/product/tags`, { headers });

      if (response?.data?.status === true) {
        setProductTagsList(response?.data?.data?.productTags);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const handleOptionSelect = (selectedOption, selectedName) => {
    setEditedData((prev) => ({ ...prev, productTagName: selectedName, productTagId: selectedOption }));
    setProductTags([]);
  };

  const handleEditModal = async (data) => {
    console.log("data :", data);

    setEditedData({
      _id: data._id,
      sequenceNumber: data?.sequenceNumber,
      name: data.name,
      description: data.description,
      hsn: data.hsn,
      taxPercent: data.taxPercent,
      makingTime: data.makingTime,
      mrp: data.mrp,
      status: data?.status,
      category: data?.category?._id,
      taxPercent: data?.taxPercent,
      offerPrice: data?.offerPrice,
      foodType: data?.foodType,
      classType: data?.classType,
      productTagId: data?.productTag?._id,
      productTagName: data?.productTag?.tagName,
      isEventProduct: data?.isEventProduct,
      isFreebieProduct: data?.isFreebieProduct, // Added new field
      // keywords: data?.keywords ? data?.keywords.split(',') : []  // Convert keywords to an array
      calories: data?.calories,
      weight: data?.weight,
      weightUnit: data?.weightUnit,
      orderType: data?.orderType,
      isNewProduct: data?.isNewProduct,
      productCost: data?.productCost
    });
    if (data) {
      setSelected(data.keywords && data.keywords.length > 0 ? data.keywords.split(',') : []);
    }
    let selectedExOutlet = data?.excludedOutletDetails;
    let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
    ({
      value: m?._id,
      label: m?.name
    }))
    setEditedSelectedExOutlets(mappedSelectedExOutlet);
    let selectedNature = data?.productsNature;
    let mappedSelectedNature = selectedNature?.map((m) => m);
    setSelectedNature(mappedSelectedNature);
    // setOpenEditModal(true);
    navigate(`/menu/update-menu/${data?._id}`);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleEditSelectChange = (selected) => {
    setEditedSelectedExOutlets(selected);
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    let _prodKeywords;
    if (selected.length > 0) {
      const _selectedodified = selected.map(val => val.trim());
      _prodKeywords = _selectedodified.join(',');
    } else {
      toast.error("Product keywords is required", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }

    setIsEditBtnLoading(true);

    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      // console.log("newEdited Data order type :", newEditedData?.orderType);

      let selectedExOutlets = editedSelectedExOutlets?.map((ex) => ex?.value);
      let newEditedData = {
        ...editedData,
        excludedOutlets: selectedExOutlets
      }

      const formData = new FormData();
      formData.append("_id", newEditedData._id);
      formData.append("sequenceNumber", newEditedData.sequenceNumber);
      formData.append("category", newEditedData.category);
      formData.append("name", newEditedData.name);
      formData.append("description", newEditedData.description);
      formData.append("hsn", newEditedData.hsn);
      formData.append("taxPercent", newEditedData.taxPercent);
      formData.append("status", newEditedData.status)
      // formData.append("makingTime", newEditedData.makingTime);
      if (newEditedData.makingTime) {
        formData.append("makingTime", newEditedData.makingTime);
      }
      formData.append("mrp", newEditedData.mrp);
      formData.append("offerPrice", newEditedData.offerPrice);
      formData.append("isEventProduct", newEditedData.isEventProduct);
      formData.append("isFreebieProduct", newEditedData.isFreebieProduct); // Added new field
      if (editedData?.productTagId) {
        formData.append("productTag[productTagId]", newEditedData.productTagId);
      }
      formData.append("productTag[productTagName]", newEditedData.productTagName);
      formData.append("foodType", newEditedData.foodType);
      formData.append("classType", newEditedData.classType);
      formData.append("calories", newEditedData.calories);
      formData.append("weight", newEditedData.weight);
      formData.append("weightUnit", newEditedData.weightUnit);
      formData.append("isNewProduct", newEditedData.isNewProduct);
      formData.append("orderType", newEditedData.orderType);
      formData.append("keywords", _prodKeywords);
      formData.append("productCost", newEditedData?.productCost ? newEditedData?.productCost : 0)

      // Check if excluded outlets are empty
      if (selectedExOutlets.length === 0) {
        // Explicitly set excludedOutlets to an empty array (JSON.stringify([]))
        // formData.append("excludedOutlets", JSON.stringify([]));

        // Explicitly set excludedOutlets to null
        formData.append("excludedOutlets", null);
      } else {
        selectedExOutlets.forEach((outlet, index) => {
          formData.append(`excludedOutlets[${index}]`, outlet);
        });
      }

      if (selectedNature.length === 0 || selectedNature.length === undefined) {
        // Explicitly set excludedOutlets to an empty array (JSON.stringify([]))
        // formData.append("productsNature", JSON.stringify([]));

        // Explicitly set excludedOutlets to null
        formData.append("productsNature", null);
      } else {
        // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
        selectedNature.forEach((outlet, index) => {
          formData.append(`productsNature[${index}]`, outlet);
        });
      }

      for (let pair of formData.entries()) {
        console.log(`${pair[0]}: ${pair[1]}`);
      }

      const response = await axios.put("product", formData, { headers });

      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter);
        getSingleProductDetails(editedData._id);
        setOpenEditModal(false);
        setOpenViewModal(true);
      }
    } catch (error) {
      if (error?.response) {
        let errorMessage = '';
        if (
          error.response?.status === 406
        ) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        }
        else if (
          error.response?.status === 412
        ) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsEditBtnLoading(false);
    }
  };

  const handleView = (item) => {
    // Handle view logic here
    console.log("Viewing:", item);
    getSingleProductDetails(item?._id);
    // setOpenViewModal(true);
    navigate(`/reports/product-detail-report/${item?._id}/${item?.name}`);
  };

  const handleDeleteModal = async (data) => {
    setOpenDeleteModal(true);
    setProductId(data?._id);
  };

  const handleDeleteProducts = async (e) => {
    e.preventDefault();
    setIsDeleteBtnLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const data = {
        _id: productId,
      };

      const response = await axios.delete(`product`, { data, headers });
      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter);
        setOpenDeleteModal(false);
      }
    } catch (error) {
      console.log("Delete Product :", error);

      if (error.response.status === 403) {
        toast.error(error?.response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }

      if (error.response.status === 404) {
        toast.error(error?.response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }

      if (error.response.status === 406) {
        toast.error(error?.response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }

      if (error.response.status === 412) {
        toast.error((error?.response?.data?.message || error?.response?.data?.data?.message), {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }

      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsDeleteBtnLoading(false);
    }
  };

  const handleOpenImageModal = (id) => {
    setOpenEditImageModal(true);
    setImageId(id);
  };

  const handleImageChange = (e) => {
    const input = document.getElementById("imageInput");
    const file = input.files[0];
    if (file) {
      const validFormats = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/avif', 'image/webp'];
      console.log("File Type :", file.type);

      if (!validFormats.includes(file.type)) {
        setImageError('Invalid file format. Only PNG, JPG, JPEG, GIF, WEBP, and AVIF are allowed.');
        return;
      }
      const reader = new FileReader();
      setDisplayImage(file);


      // reader.onloadend = () => {
      //   const image = new Image();
      //   image.src = reader.result;

      //   image.onload = () => {
      //     const width = image.width;
      //     const height = image.height;

      //     const maxWidth = 400;
      //     const maxHeight = 400;

      //     if (width === maxWidth && height === maxHeight) {
      //       // alert("Image dimensions are valid!");
      //       setDisplayImage(file);
      //     } else {
      //       alert(
      //         "Image dimensions are not valid. Please choose an image with dimensions equal to " +
      //         maxWidth +
      //         "x" +
      //         maxHeight
      //       );
      //       input.value = "";
      //     }
      //   };
      // };
      reader.readAsDataURL(file);
    }
  }

  const handleSumbitUpdateImage = async (e) => {
    e.preventDefault();
    setIsImageLoading(true);
    try {
      const formData = new FormData();
      formData.append("_id", imageId);
      if (displayImage) {
        formData.append("displayImage", displayImage);
      }
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.put("product", formData, { headers });

      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });

        e.target.reset();
        setDisplayImage("");
        const input = document.getElementById("imageInput");
        getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter);
        input.value = "";
        setOpenEditImageModal(false);
      }
    } catch (error) {
      console.log("Error :", error);

      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        } else if (error.response?.status === 400) {
          errorMessage = error?.response?.data?.message;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsImageLoading(false);
    }
  }

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchProducts = () => {
    const lowerCaseSearchText = searchText.toLowerCase();
    const filteredData = productsList.filter((item) => {
      const nameMatch = item.name.toLowerCase().includes(lowerCaseSearchText);
      const tagMatch = item.productTag && item.productTag.tagName.toLowerCase().includes(lowerCaseSearchText);
      return nameMatch || tagMatch;
    });
    setFilteredProducts(filteredData);
  };

  const handleOpenCoverImageModal = (id) => {
    console.log("Hello");

    setImageId(id); // Save the product ID for submission
    setShowEditCoverModal(true);
  };

  const handleCoverPictureChange = (e) => {
    const fileInput = document.getElementById('newCoverImage');
    const file = fileInput?.files[0];
    if (file) {
      setCoverImage(file); // Update the state with the selected file
    }
  };

  const handleSumbitUpdateCoverImage = async (e) => {
    // e.preventDefault();
    setIsCoverImageLoading(true);

    try {
      const formData = new FormData();
      formData.append('_id', imageId); // Use the product ID stored earlier
      if (coverImage) {
        formData.append('coverPicture', coverImage); // Attach the selected cover image
      }

      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      };

      const response = await axios.put('product', formData, { headers });
      console.log("response");

      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: 'top-right',
          autoClose: 3000,
          theme: 'colored',
        });
        // e.target.reset();
        setCoverImage(null);
        const input = document.getElementById('newCoverImage');
        input.value = ''; // Clear the file input  
      }
      getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter); // Refresh the product list to reflect the updated cover image
      getSingleProductDetails(imageId);
      setShowEditCoverModal(false);
    } catch (error) {
      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage =
            error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }

        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 3000,
          theme: 'colored',
        });
      }
    } finally {
      setIsCoverImageLoading(false);
    }
  };

  const handlePrintReport = () => {
    const tableContent = `
      <table style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Sr.No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Menu Name</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Category</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Class Type</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Food Type</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Making Time</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left; width: 70px">Price</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left; width: 70px">Offer Price</th>
          </tr>
        </thead>
        <tbody>
          ${productsList?.length > 0 ?
        productsList?.map((product, index) => `
              <tr>
                <td style="border: 1px solid black; padding: 8px;">${index + 1}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.name}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.category?.name}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.classType}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.foodType}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.makingTime} mins</td>
                <td style="border: 1px solid black; padding: 8px;">₹. ${product?.mrp}</td>
                <td style="border: 1px solid black; padding: 8px;">₹. ${product?.offerPrice}</td>
              </tr>
            `).join("") :
        `<tr>
              <td colspan="8" style="border: 1px solid black; padding: 8px; text-align: center;">No Menu Items Found</td>
            </tr>`
      }
        </tbody>
      </table>
    `;

    const win = window.open("", "", "width=900,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Print Table</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <h2>Menu Report</h2>
          <div>${tableContent}</div>
        </body>
      </html>
    `);
    win.document.close();
  };

  const handleBulkUpdatePricePdf = () => {
    const newFilteredData = filteredProducts.filter(fil => fil.status === 'ACTIVE');
    const tableContent = `
      <table style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">product</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">productName</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Category</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">mrpPrice</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">offerPrice</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">status</th>
          </tr>
        </thead>
        <tbody>
          ${newFilteredData?.length > 0 ?
        newFilteredData?.map((product, index) => `
              <tr>
                <td style="border: 1px solid black; padding: 8px;">${product?._id}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.name}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.category?.name}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.mrp}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.offerPrice}</td>
                <td style="border: 1px solid black; padding: 8px;">${product?.status}</td>
              </tr>
            `).join("") :
        `<tr>
              <td colspan="4" style="border: 1px solid black; padding: 8px; text-align: center;">No Menu Items Found</td>
            </tr>`
      }
        </tbody>
      </table>
    `;
    const win = window.open("", "", "width=900,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Bulk Price Update Format</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <h2>Bulk Price Update Format</h2>
          <div>${tableContent}</div>
        </body>
      </html>
    `);
    win.document.close();
  };

  const handlePrint = () => {
    const product = productDetails;
    const displayImage = product?.imageURL || '';
    const coverImage = product?.coverImageURL || '';

    const newWin = window.open('', '', 'width=900,height=650');

    newWin.document.write(`
      <html>
        <head>
          <title>Product Details</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 30px;
              color: #000;
            }
            h2 {
              text-align: center;
              margin-bottom: 40px;
              text-decoration: underline;
            }
            .images {
              display: flex;
              justify-content: space-between;
              gap: 20px;
              margin-bottom: 30px;
            }
            .images img {
              width: 48%;
              max-height: 250px;
              object-fit: cover;
              border: 1px solid #ccc;
              border-radius: 10px;
            }
            .section-title {
              font-size: 18px;
              margin-top: 30px;
              margin-bottom: 10px;
              text-decoration: underline;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            th, td {
              padding: 10px;
              border: 1px solid #ddd;
              vertical-align: top;
              text-align: left;
            }
            th {
              background-color: #f5f5f5;
              width: 30%;
            }
            ul {
              margin: 0;
              padding-left: 20px;
            }
          </style>
        </head>
        <body>
          <h2>Product Details</h2>

          <div class="images">
            <div>
              <p style="font-weight: bold;">Cover Image</p>
              <img src="${coverImage}" alt="Cover Image" />
            </div>
            <div>
              <p style="font-weight: bold;">Display Image</p>
              <img src="${displayImage}" alt="Display Image" />
            </div>
          </div>

          <div class="section-title">General Info</div>
          <table>
            <tr><th>Name</th><td>${product?.name || 'N/A'}</td></tr>
            <tr><th>Category</th><td>${product?.category?.name || 'N/A'}</td></tr>
            <tr><th>Class Type</th><td>${product?.classType || 'N/A'}</td></tr>
            <tr><th>Order Type</th><td>${product?.orderType || 'N/A'}</td></tr>
            <tr><th>Outlet Type</th><td>${product?.isEventProduct ? 'For Event Outlet' : 'For Regular Outlet'}</td></tr>
            <tr><th>New Badge</th><td>${product?.isNewProduct ? 'ENABLED' : 'DISABLED'}</td></tr>
            <tr><th>Freebie Product</th><td>${product?.isFreebieProduct ? 'YES' : 'NO'}</td></tr>
            <tr><th>Sequence Number</th><td>${product?.sequenceNumber || 'N/A'}</td></tr>
          </table>

          <div class="section-title">Pricing & Attributes</div>
          <table>
            <tr><th>Offer Price</th><td>₹ ${product?.offerPrice?.toFixed(2) || 0}</td></tr>
            <tr><th>MRP</th><td>₹ ${product?.mrp?.toFixed(2) || 0}</td></tr>
            <tr><th>Calories</th><td>${product?.calories || 'N/A'}</td></tr>
            <tr><th>Weight</th><td>${product?.weight || 'N/A'} ${product?.weightUnit || ''}</td></tr>
            <tr><th>HSN</th><td>${product?.hsn || 'N/A'}</td></tr>
            <tr><th>Keywords</th><td>${product?.keywords || 'N/A'}</td></tr>
          </table>

          <div class="section-title">Excluded Outlets</div>
          <p>${product?.excludedOutletDetails?.length > 0
        ? product.excludedOutletDetails.map(outlet => outlet.name).join(', ')
        : 'No outlets excluded'
      }</p>

          <div class="section-title">Description</div>
          <p>${product?.description || 'N/A'}</p>

          ${product?.productAddons?.length > 0
        ? `
              <div class="section-title">Addons</div>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Addon Title</th>
                    <th>Multiple Select</th>
                    <th>Addon Values</th>
                  </tr>
                </thead>
                <tbody>
                  ${product.productAddons.map((addon, idx) => `
                    <tr>
                      <td>${idx + 1}</td>
                      <td>${addon.addonTitle}</td>
                      <td>${addon.isMultipleSelect ? 'Yes' : 'No'}</td>
                      <td>
                        <ul>
                          ${addon.addonValues.map(val => `<li>${val.value} - ₹ ${val.offerPrice?.toFixed(2)}</li>`).join('')}
                        </ul>
                      </td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            ` : ''
      }

        </body>
      </html>
    `);

    newWin.document.close();
    newWin.onload = () => {
      newWin.focus();
      newWin.print();
      newWin.close();
    };
  };

  useEffect(() => {
    getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter);
    getCategoryList();
    getOutlets();
    getProductTags();
    getProductTagsList();
  }, []);

  useEffect(() => {
    if (searchText === "") {
      getProductsList(categoryFilter, productTagFilter, statusFilter, foodTypeFilter, orderTypeFilter);
    }
  }, [searchText]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div
          className="container shadow-sm"
          style={{ backgroundColor: "white" }}
        >
          <Row className="pt-4">
            <Col>
              <h5 className="fw-semibold">MENU CATALOG</h5>
            </Col>
          </Row>

          <Row style={{ backgroundColor: "whitesmoke" }}>
            <Col md={3} lg={3} className="mt-3">
              <Select
                options={[
                  { value: "", label: "Category" },
                  ...categoryList.map((rm) => ({
                    value: rm._id,
                    label: rm.name,
                  })),
                ]}
                onChange={(selectedOption) =>
                  handleCategoryFilter({
                    target: { value: selectedOption?.value || "" },
                  })
                }
                placeholder="Category"
                isClearable
                components={animatedComponents}
                // styles={customStyles}
                styles={{
                  ...customStyles,
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                closeMenuOnSelect={false}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary25: "#e9ecef",
                    primary: "#007bff",
                  },
                })}
              />
            </Col>
            <Col md={4} lg={3} className="mt-3">
              <Form.Select onChange={handleOrderTypeFilter}>
                <option value="">Orders Type</option>
                <option value="BOTH">BOTH</option>
                <option value="PICKUP">PICKUP</option>
                <option value="DELIVERY">DELIVERY</option>
              </Form.Select>
            </Col>

            <Col md={4} lg={3} className="mt-3">
              <Form.Select onChange={handleStatusFilter}>
                <option value="all" >All Products</option>
                <option value="ACTIVE" className="text-success">✅ Active Products</option>
                <option value="INACTIVE" className="text-danger">❌ Inactive Products</option>
                <option value="NEW" className="text-primary">🆕 New Products</option>
                <option value="FREEBIE" className="text-primary">⭐ Freebie Products</option>
              </Form.Select>
            </Col>
            <Col md={4} lg={3} className="mt-3">
              <Form.Select onChange={handleFoodTypeFilter}>
                <option value="all">Food Type</option>
                <option value="VEG">VEG</option>
                <option value="NON-VEG">NON-VEG</option>
                <option value="VEGAN">VEGAN</option>
              </Form.Select>
            </Col>
            {/* <Col md={3} lg={2} className="mt-3">
              <Form.Select  className="border-warning">
                <option value="all">All Products</option>
                <option value="new" className="text-success fw-semibold">
                  🆕 New Products
                </option>
              </Form.Select>
            </Col> */}
          </Row>

          <Row style={{ backgroundColor: 'whitesmoke' }}>
            <Col md={4} lg={3} className="mt-3">
              <Form.Select onChange={handleProductTagFilter}>
                <option value="all">Product Tag</option>
                {productTagsList.map((rm) => (
                  <option key={rm._id} value={rm._id}>
                    {rm.tagName}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md="3" className="mt-3">
              <div className="input-group w-100">
                <input
                  type="text"
                  value={searchText}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search for Menu Items"
                />
                <button className="btn btn-primary" type="button" onClick={handleSearchProducts}>
                  <i className="ri-search-line"></i> Search
                </button>
              </div>
            </Col>

            <Col md="3">
              <div className="mt-3">
                <Button className="w-100 fw-semibold" variant="primary" style={{ fontSize: '13.5px' }} onClick={handleBulkUpdatePricePdf}>Get Bulk Price Update Format</Button>
              </div>
            </Col>
            <Col md="3">
              <div className="mt-3">
                <Button className="w-100 fw-semibold" variant="success" onClick={handlePrintReport}>Print Report</Button>
              </div>
            </Col>
          </Row>

          {/* <------- Product Card --------> */}
          {/* {(menuAccess?.includes("MenuCatalog:get" || email === "contact@xpansecafe.com")) && ( */}
          <Row style={{ backgroundColor: "whitesmoke" }}>
            {productLoading ? (
              // Skeleton Loader with 8 skeleton cards
              Array.from({ length: 12 }).map((_, index) => (
                <Col
                  style={{ marginTop: "60px" }}
                  key={`skeleton-${index}`}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={2}
                >
                  <Card
                    className="shadow-sm mb-4"
                    style={{
                      width: "100%",
                      position: "relative",
                      height: "28vh",
                      borderRadius: "10px",
                      background: "#fff",
                      // overflow: "hidden",
                    }}
                  >
                    {/* Skeleton for NEW badge */}
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "-8px",
                        zIndex: 2,
                      }}
                    >
                      <div
                        style={{
                          width: "45px",
                          height: "18px",
                          clipPath: "polygon(0 0, 100% 0, 85% 50%, 100% 100%, 0 100%)",
                          background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                          backgroundSize: "200% 100%",
                          animation: "skeletonPulse 1.5s infinite",
                        }}
                      />
                    </div>

                    {/* Skeleton for order type badge */}
                    {/* <div
                          style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              width: "55px",
                              height: "18px",
                              borderRadius: "10px",
                              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "skeletonPulse 1.5s infinite",
                            }}
                          />
                        </div> */}

                    {/* Skeleton for product image */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-45px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        height: "80px",
                        width: "80px",
                        borderRadius: "50%",
                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "skeletonPulse 1.5s infinite",
                        zIndex: 1,
                      }}
                    />

                    <Card.Body className="mt-1 ps-4" style={{ paddingTop: "45px" }}>
                      {/* Skeleton for product title */}
                      <Row style={{ height: "3vh", marginBottom: "10px" }}>
                        <div
                          style={{
                            width: "90%",
                            height: "16px",
                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                            backgroundSize: "200% 100%",
                            animation: "skeletonPulse 1.5s infinite",
                            borderRadius: "4px",
                            marginBottom: "8px",
                          }}
                        />
                        {/* <div
                              style={{
                                width: "70%",
                                height: "16px",
                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                backgroundSize: "200% 100%",
                                animation: "skeletonPulse 1.5s infinite",
                                borderRadius: "4px",
                              }}
                            /> */}
                      </Row>

                      <hr style={{ margin: "10px 0" }} />

                      {/* Skeleton for category and food type */}
                      <Row className="mt-1" style={{ height: "3vh", marginBottom: "1px" }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div
                            style={{
                              width: "60%",
                              height: "14px",
                              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "skeletonPulse 1.5s infinite",
                              borderRadius: "4px",
                            }}
                          />
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "skeletonPulse 1.5s infinite",
                            }}
                          />
                        </div>
                      </Row>

                      {/* Skeleton for pricing */}
                      <Row className="mb-1" style={{ fontSize: "10px", marginBottom: "15px" }}>
                        <div
                          style={{
                            width: "85%",
                            height: "12px",
                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                            backgroundSize: "200% 100%",
                            animation: "skeletonPulse 1.5s infinite",
                            borderRadius: "4px",
                            marginBottom: "8px",
                          }}
                        />
                        {/* <div
                              style={{
                                width: "80%",
                                height: "12px",
                                background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                backgroundSize: "200% 100%",
                                animation: "skeletonPulse 1.5s infinite",
                                borderRadius: "4px",
                                marginBottom: "8px",
                              }}
                            /> */}
                        <div
                          style={{
                            width: "90%",
                            height: "12px",
                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                            backgroundSize: "200% 100%",
                            animation: "skeletonPulse 1.5s infinite",
                            borderRadius: "4px",
                          }}
                        />
                      </Row>

                      {/* Skeleton for action buttons */}
                      <Row style={{ marginBottom: "10px" }}>
                        <div className="d-flex justify-content-center gap-2">
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "4px",
                              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "skeletonPulse 1.5s infinite",
                            }}
                          />
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "4px",
                              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "skeletonPulse 1.5s infinite",
                            }}
                          />
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "4px",
                              background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "skeletonPulse 1.5s infinite",
                            }}
                          />
                        </div>
                      </Row>

                      {/* Skeleton for status */}
                      <Row style={{
                        margin: "0 -15.9px -15.9px -23.9px",
                      }}>
                        <div
                          style={{
                            width: '100%',
                            // width: "calc(100% + 31.8px)",
                            height: "25px",
                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                            backgroundSize: "200% 100%",
                            animation: "skeletonPulse 1.5s infinite",
                            borderRadius: "0 0 10px 10px",
                            // margin: "0 -15.9px -15.9px -11.9px",
                            // margin: "0 0 -15.9px -11.9px",

                          }}
                        ></div>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : filteredProducts?.length === 0 ? (
              // Empty State
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "30vh", width: "100%" }}>
                <div className="text-center">
                  <div className="text-muted mb-2">
                    <i className="fas fa-box-open" style={{ fontSize: "3rem", opacity: 0.5 }}></i>
                  </div>
                  <p className="text-muted">No products found</p>
                </div>
              </div>
            ) : (
              filteredProducts?.map((item, index) => (
                <Col
                  style={{ marginTop: "60px" }}
                  key={index}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={2}
                >
                  <Card
                    className="shadow-sm mb-4"
                    style={{
                      width: "100%",
                      position: "relative",
                      height: "28vh",
                      borderRadius: "10px",

                    }}
                  >
                    
                    {item?.isNewProduct && (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "-8px",
                          zIndex: 2,
                        }}
                      >
                        <span
                          style={{
                            // backgroundColor: "#28a745",
                            backgroundColor: '#FBED21',
                            color: "#00A4E2",
                            padding: "2px 19px 2px 14px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                            clipPath: "polygon(0 0, 100% 0, 85% 50%, 100% 100%, 0 100%)",
                            border: "1px solid rgba(255,255,255,0.3)",
                          }}
                        >
                          NEW
                        </span>
                      </div>
                    )}

                    {/* Order Type Indicator - Top Right Corner */}
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 1,
                      }}
                    >
                      {(() => {
                        if (item?.orderType === "ALL") {
                          return (
                            <span
                              style={{
                                backgroundColor: "#6f42c1", // Purple for ALL
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: "10px",
                                fontSize: "9px",
                                fontWeight: "bold",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                              }}
                            >
                              BOTH
                            </span>
                          );
                        } else if (item?.orderType === "DELIVERY") {
                          return (
                            <span
                              style={{
                                backgroundColor: "#20c997", // Teal for Delivery
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: "10px",
                                fontSize: "9px",
                                fontWeight: "bold",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                              }}
                            >
                              DELIVERY
                            </span>
                          );
                        } else if (item?.orderType === "PICKUP") {
                          return (
                            <span
                              style={{
                                backgroundColor: "#fd7e14", // Orange for Pickup
                                color: "white",
                                padding: "2px 8px",
                                borderRadius: "10px",
                                fontSize: "9px",
                                fontWeight: "bold",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                              }}
                            >
                              PICKUP
                            </span>
                          );
                        }
                        return null;
                      })()}
                    </div>
                    {/* Badge for Status */}
                    {/* <div
                          style={{
                            position: "absolute",
                            top: "20px",
                            right: "50px",
                            fontSize: "0.7rem",
                            color: "white",
                            padding: "0", // Remove padding for consistent dimensions
                            width: "24px", // Set width for the circle
                            height: "24px", // Set height for the circle (same as width)
                            display: "flex", // Center the content
                            justifyContent: "center", // Center horizontally
                            alignItems: "center", // Center vertically
                            borderRadius: "50%", // Makes it a circle
                            zIndex: "1",
                            backgroundColor: "rgba(22, 36, 128, 0.7)",
                            color:'white'
                          }}
                        >
                          {item?.sequenceNumber}
                        </div> */}
                    <Image
                      onClick={() => handleOpenImageModal(item?._id)}
                      style={{
                        // position: "absolute",
                        // bottom: 170,
                        // height: "90px",
                        // width: "90px",
                        // alignSelf: "center",

                        position: "absolute",
                        top: "-5%", // Center vertically
                        left: "50%", // Center horizontally
                        transform: "translate(-50%, -50%)", // Perfect centering
                        height: "clamp(70px, 15vw, 85px)", // Responsive height
                        width: "clamp(70px, 15vw, 85px)", // Responsive width
                        maxHeight: "90px",
                        maxWidth: "90px",
                        objectFit: "contain",
                        alignSelf: "center"
                      }}
                      src={item?.imageURL}
                      variant="top"
                      fluid
                    />
                    <Card.Body style={{ paddingTop: "45px" }}>
                      <Row style={{ height: "5vh" }}>
                        <Card.Title
                          className="justify-content-center align-items-center"
                          style={{
                            fontSize: "13px",
                            display: "-webkit-box", // Enables line clamping
                            WebkitLineClamp: 2, // Limits the text to 2 lines
                            WebkitBoxOrient: "vertical", // Maintains vertical flow of text
                            overflow: "hidden", // Hides overflowing text
                            textOverflow: "ellipsis", // Adds ellipsis for overflowing text
                          }}
                        >
                          <span style={{}}>{item?.name}</span>
                        </Card.Title>
                      </Row>
                      <hr style={{ margin: 0 }} />
                      <Row className="mt-1" style={{ height: "3vh" }}>
                        <Card.Text
                          className="d-flex justify-content-between align-items-center"
                          style={{ fontSize: "11px" }}
                        >
                          <>{item?.category?.name}</>
                          <Image
                            src={`${item?.foodType === "VEG"
                                ? "/images/veg.png"
                                : item?.foodType === "NON-VEG"
                                  ? "/images/nonveg.png"
                                  : "/images/vegan.png"
                              }`}
                            style={{ width: "15px" }}
                          />{" "}
                        </Card.Text>
                      </Row>
                      <Row className="mb-1" style={{ fontSize: "10px" }}>
                        <Col className="fw-semibold text-primary" md="12">
                          Costing -  {item?.productCost ? `₹ ${item?.productCost}` : 'N/A'}
                        </Col>
                      {!item?.isFreebieProduct && (
                        <>
                          <Col className="fw-semibold text-danger" md="12">
                            MRP - ₹ {item?.mrp}
                          </Col>
                          <Col className="fw-bold text-success" md="12">
                            Offer Price - ₹ {item?.offerPrice}
                          </Col>
                        </>
                      )}
                      </Row>
                      {item?.isFreebieProduct && (
                        <Row className="mb-1" style={{ fontSize: "12px", marginTop: "5px" }}>
                          <Col className="fw-semibold text-center" style={{ color: "#ff866b" }} md="12">
                            <i className="fas fa-gift me-1"></i>FREEBIE PRODUCT
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <ButtonGroup
                          className="text-center mb-1"
                          aria-label="Basic example"
                        >
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => handleView(item)}
                            disabled={!menuAccess.includes("MenuCatalog:get") && email === ""}
                          >
                            <EyeFill />
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => handleEditModal(item)}
                            disabled={!menuAccess.includes("MenuCatalog:update") && email === ""}
                          >
                            <PencilFill />
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => handleDeleteModal(item)}
                            disabled={!menuAccess.includes("MenuCatalog:delete") && email === ""}
                          >
                            <TrashFill />
                          </Button>
                        </ButtonGroup>
                      </Row>
                      <Row
                        style={{
                          display: "flex",
                          marginTop: "5.5px",
                          marginRight: "-15.9px",
                          marginLeft: "-15.9px",
                        }}
                      >
                        <Col
                          className={`text-center text-white ${item.status === "ACTIVE"
                              ? "bg-success"
                              : "bg-secondary"
                            }`}
                          md="12"
                          style={{
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }}
                        >
                          {item.status}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            )}
          </Row>


          {openEditModal ? (
            <Modal
              show={openEditModal}
              onHide={() => setOpenEditModal(false)}
              centered
              aria-labelledby="VerticallyCenteredExample"
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title id="VerticallyCenteredExample" className="fs-5 fw-semibold">
                  UPDATE PRODUCT
                </Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleEditSubmit}>
                <Modal.Body>
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Sequence Number <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="Sequence Number"
                          className="form-control no-arrows"
                          name="sequenceNumber"
                          value={editedData?.sequenceNumber}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Select Category <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          onChange={handleEditChange}
                          name="category"
                          value={editedData?.category}
                        >
                          <option value="">Select Category</option>
                          {categoryList.map((rm) => (
                            <option key={rm._id} value={rm._id}>
                              {rm.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Menu Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Name"
                          className="form-control"
                          name="name"
                          value={editedData?.name}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Class Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          onChange={handleEditChange}
                          name="classType"
                          value={editedData?.classType}
                        >
                          <option value="">Class Type</option>
                          <option value="FOOD">FOOD</option>
                          <option value="BEVERAGE">BEVERAGE</option>
                          <option value="COMBOS">COMBOS</option>
                          <option value="DESSERTS">DESSERTS</option>
                          <option value="EXTRAS">EXTRAS</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          HSN <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="HSN"
                          className="form-control"
                          name="hsn"
                          value={editedData?.hsn}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Calories <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="Calories"
                          className="form-control no-arrows"
                          name="calories"
                          value={editedData?.calories}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Weight <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="Weight"
                          className="form-control no-arrows"
                          name="weight"
                          value={editedData?.weight}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Weight Unit <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          onChange={handleEditChange}
                          name="weightUnit"
                          value={editedData?.weightUnit}
                        >
                          <option value="">Weight Unit</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="GMS">GRAMS</option>
                          <option value="LITRES">LITRES</option>
                          <option value="ML">MILLI-LITRE</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Tax Percent <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          max={100}
                          type="number"
                          step="any"
                          placeholder="Tax Percent"
                          className="form-control no-arrows"
                          name="taxPercent"
                          value={editedData?.taxPercent}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Order Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="orderType"
                          value={editedData.orderType}
                          onChange={handleEditChange}
                        >
                          <option value="" disabled>Select</option>
                          <option value="ALL">ALL</option>
                          <option value="DELIVERY">DELIVERY</option>
                          <option value="PICKUP">PICK-UP</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {/* <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Delivery Making Time <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="In Mins"
                          className="form-control no-arrows"
                          name="deliveryMakingTime"
                          value={editedData?.deliveryMakingTime}
                          onChange={handleEditChange}
                          disabled={editedData?.orderType === "PICKUP"}
                        />
                      </Form.Group>
                    </Col> */}

                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Making Time <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="In Mins"
                          className="form-control no-arrows"
                          name="makingTime"
                          value={editedData?.makingTime}
                          onChange={handleEditChange}
                          disabled={editedData?.orderType === "DELIVERY"}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={2}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Product Costing
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="In Rupees"
                          className="form-control no-arrows"
                          name="productCost"
                          value={editedData?.productCost}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={2}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          MRP <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          step="any"
                          placeholder="In Rupees"
                          className="form-control no-arrows"
                          name="mrp"
                          disabled
                          value={editedData?.mrp}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Offer Price <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          min={0}
                          type="number"
                          disabled
                          step="any"
                          placeholder="In Rupees"
                          className="form-control no-arrows"
                          name="offerPrice"
                          value={editedData?.offerPrice}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md="3">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Select Status <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="status"
                          value={editedData.status}
                          onChange={handleEditChange}
                        >
                          <option value="">Select Status</option>
                          <option value="ACTIVE">ACTIVE</option>
                          <option value="INACTIVE">INACTIVE</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md="3">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Select Food Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="foodType"
                          value={editedData.foodType}
                          onChange={handleEditChange}
                        >
                          <option value="">Select Food Type</option>
                          <option value="VEG">VEG</option>
                          <option value="NON-VEG">NON-VEG</option>
                          <option value="VEGAN">VEGAN</option>
                          <option value="VEG/VEGAN">VEG/VEGAN</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {/* Is Freebie Product */}
                    <Col md="2">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Is Freebie Product <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="isFreebieProduct"
                          value={editedData.isFreebieProduct}
                          onChange={handleEditChange}
                        >
                          <option value="">Select</option>
                          <option value="true">YES</option>
                          <option value="false">NO</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md="2">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Enable New Badge <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="isNewProduct"
                          value={editedData.isNewProduct}
                          onChange={handleEditChange}
                        >
                          <option value="" disabled>
                            New Badge
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md="2">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Outlet Type <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="isEventProduct"
                          value={editedData.isEventProduct}
                          onChange={handleEditChange}
                        >
                          <option value="" disabled>
                            Select Outlet Type
                          </option>
                          <option value="false">Regular Outlet</option>
                          <option value="true">Event Outlet</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md="2">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Product Tag Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Product Tag Name"
                          name="productTagName"
                          onChange={handleSearchText}
                          value={editedData?.productTagName}
                        />
                        {productTags && productTags.length > 0 && (
                          <div className="dropdown-menu">
                            {productTags.map((prod) => (
                              <div
                                key={prod._id}
                                style={{
                                  marginTop: '-10px',
                                  padding: '5px',
                                  cursor: 'pointer',
                                }}
                                onClick={() =>
                                  handleOptionSelect(prod._id, prod.tagName)
                                }
                              >
                                {prod.tagName}
                              </div>
                            ))}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="6">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Select Excluded Outlets
                        </Form.Label>
                        <Select
                          isMulti
                          components={animatedComponents}
                          value={editedSelectedExOutlets}
                          onChange={handleEditSelectChange}
                          options={outletData}
                          styles={customStyles}
                          placeholder="Select Excluded Outlets"
                          closeMenuOnSelect={false}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                              primary25: "#e9ecef",
                              primary: "#007bff",
                            },
                          })}
                        />
                      </Form.Group>
                    </Col>

                    <Col md="6">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Product Keywords{' '}
                          <span className="text-danger">*</span>{' '}
                          <span
                            style={{
                              fontSize: '13px',
                              color: 'purple',
                              fontWeight: 'normal',
                            }}
                          >
                            (Press Enter After Adding Each Keyword).
                          </span>
                        </Form.Label>
                        <TagsInput
                          value={selected}
                          onChange={setSelected}
                          name="keywords"
                          placeHolder="Product Keywords"
                        />
                      </Form.Group>
                    </Col>

                    {/* Product Keywords */}
                    <Col md={6} lg={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold">
                          Nature Of Product{" "}
                          {" "}
                          <span style={{ fontSize: "13px", color: "purple", fontWeight: 'normal' }}>
                            (Press Enter After Adding Each Keyword)
                          </span>
                        </Form.Label>
                        <TagsInput
                          value={selectedNature}
                          onChange={setSelectedNature}
                          name="keywords"
                          placeHolder="Add Nature Of The Nature"
                        />
                      </Form.Group>
                    </Col>



                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Description <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Description"
                          name="description"
                          value={editedData?.description}
                          onChange={handleEditChange}
                        />
                      </Form.Group>
                    </Col>

                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" type="submit" disabled={isEditBtnLoading}>
                    {isEditBtnLoading ? <Spinner size="sm" /> : "SAVE CHANGES"}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          ) : null}

          {openEditImageModal ? (
            <Modal
              show={openEditImageModal}
              onHide={() => setOpenEditImageModal(false)}
              centered
              aria-labelledby="VerticallyCenteredExample"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title id="VerticallyCenteredExample" className="fs-6">
                  CHANGE IMAGE
                </Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleSumbitUpdateImage}>
                <Modal.Body>
                  <Form.Group controlId="imageInput">
                    <Form.Control
                      type="file"
                      className="w-100"
                      accept="image/*"
                      onChange={(e) => handleImageChange(e)}
                    />
                    {imageError && (
                      <span style={{ color: 'red', fontSize: '13px' }}>{imageError}</span>
                    )}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={!!imageError || isImageLoading}
                  >
                    {isImageLoading ? <Spinner size="sm" /> : "Save"}
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => setOpenEditImageModal(false)}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          ) : null}

          {/* Edit Cover Image Modal */}
          {showEditCoverModal && (
            <Modal
              show={showEditCoverModal}
              onHide={() => setShowEditCoverModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Edit Cover Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3">
                  <label htmlFor="newCoverImage" className="form-label">
                    Select a New Cover Image
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="newCoverImage"
                    accept="image/*"
                    onChange={(e) => handleCoverPictureChange(e)}
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="success"
                  onClick={handleSumbitUpdateCoverImage}
                  disabled={isCoverImageLoading}
                >
                  {isCoverImageLoading ? (
                    <Spinner as="span" animation="border" size="sm" />
                  ) : (
                    "Update"
                  )}
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => setShowEditCoverModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {openDeleteModal ? (
            <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this Product? This action cannot be undone.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDeleteProducts}>
                  {isDeleteBtnLoading ?
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    /> :
                    "Delete Product"
                  }
                </Button>
              </Modal.Footer>
            </Modal>
          ) : null}

          {openViewModal ? (
            <Modal show={openViewModal} onHide={() => setOpenViewModal(false)} size="xl" centered>
              <Modal.Header closeButton className="border-bottom-0 pb-0">
                <Modal.Title className="fs-5 fw-bold text-primary">VIEW PRODUCT DETAILS</Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-4">
                <div ref={printRef}>
                  <Row>
                    {/* Left Column: Cover Image and Product Details*/}
                    <Col md={12} lg={6} className="position-relative">
                      {/* Cover Image Section */}
                      <div className="position-relative mb-4">
                        <div className="d-flex justify-content-between align-items-center position-absolute top-0 start-0 w-100 p-3">
                          <Badge bg="secondary" className="fs-6">
                            {productDetails?.status}
                          </Badge>
                          {productDetails?.foodType === 'VEG/VEGAN' ? (
                            <div>
                              <Image width={24} src="/images/veg.png" className="me-2" />
                              <Image width={24} src="/images/vegan.png" />
                            </div>
                          ) : (
                            <Image
                              width={24}
                              src={
                                productDetails?.foodType === 'VEG'
                                  ? '/images/veg.png'
                                  : productDetails?.foodType === 'NON-VEG'
                                    ? '/images/nonveg.png'
                                    : '/images/vegan.png'
                              }
                            />
                          )}
                        </div>
                        <Image
                          src={productDetails?.coverImageURL || require('../../assets/coverImage.jpg')}
                          alt="Cover Picture"
                          fluid
                          className="rounded-3 shadow-sm"
                          style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                        />
                        <Button
                          variant="success"
                          size="sm"
                          className="position-absolute bottom-0 end-0 m-3"
                          style={{ borderRadius: '20px', fontWeight: '600' }}
                          onClick={() => handleOpenCoverImageModal(productDetails?._id)}
                        >
                          Update Cover Image
                        </Button>
                      </div>

                      {/* Excluded Outlets Section */}
                      <p className="mt-4 fw-bold">
                        <i className="fas fa-store-alt me-2"></i>
                        <span style={{ textDecoration: 'underline' }}>Excluded Outlets:</span>
                        <span className="ms-2 text-muted">
                          {productDetails.excludedOutletDetails?.length > 0
                            ? productDetails.excludedOutletDetails.map((outlet) => outlet.name.toLowerCase().trim()).join(', ')
                            : 'No outlets excluded'}
                        </span>
                      </p>
                      {/* Description Section */}
                      <p className="mt-3 fw-bold">
                        <i className="fas fa-align-left me-2"></i>
                        <span style={{ textDecoration: 'underline' }}>Description:</span>
                        <span className="ms-2 text-muted">{productDetails?.description}</span>
                      </p>

                      {/* Addons Section */}
                      {productDetails?.productAddons?.length > 0 && (
                        <div className="mt-4">
                          <h5 className="fw-bold mb-3">
                            <i className="fas fa-plus-circle me-2"></i>
                            Addons
                          </h5>
                          <Table bordered hover responsive>
                            <thead className="table-light">
                              <tr>
                                <th>#</th>
                                <th>Addon Title</th>
                                <th>Multiple Select</th>
                                <th>Addon Values</th>
                              </tr>
                            </thead>
                            <tbody>
                              {productDetails.productAddons.map((addon, idx) => (
                                <tr key={addon._id || idx}>
                                  <td>{idx + 1}</td>
                                  <td className="text-capitalize">{addon.addonTitle}</td>
                                  <td>{addon.isMultipleSelect ? 'Yes' : 'No'}</td>
                                  <td>
                                    <ul className="mb-0 ps-3">
                                      {addon.addonValues?.map((val, vIdx) => (
                                        <li key={vIdx}>
                                          {val.value} - ₹ {val?.offerPrice?.toFixed(2)}
                                        </li>
                                      ))}
                                    </ul>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Col>

                    {/* Right Column: Additional Product Details */}
                    <Col md={12} lg={6}>
                      {/* Product Image */}
                      {/* <div className="text-center mb-3">
                        <Image
                          src={productDetails?.imageURL}
                          alt="Product Image"
                          fluid
                          className="rounded-3"
                          style={{ maxWidth: '200px', height: 'auto' }}
                        />
                      </div>
                      <div className="mb-4">
                        <Button
                          variant="primary"
                          size="sm"
                          style={{ borderRadius: '20px', fontWeight: '600' }}
                          onClick={() => handleOpenCoverImageModal(productDetails?._id)}
                        >
                          Update Product Image
                        </Button>
                      </div> */}
                      <Table bordered hover>
                        <tbody>
                          <tr>
                            <td className="fw-semibold bg-light w-25">Seq Number</td>
                            <td className="fw-semibold">{productDetails?.sequenceNumber}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Name</td>
                            <td className="fw-semibold">{productDetails?.name}</td>
                          </tr>
                          {/* <tr>
                            <td className="fw-semibold bg-light">Created On</td>
                            <td>
                              {productDetails?.productTag?.createdAt
                                ? new Date(productDetails?.productTag?.createdAt).toLocaleString('en-US', {
                                    year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true
                                  })
                                : '--------'}
                            </td>
                          </tr> */}
                          <tr>
                            <td className="fw-semibold bg-light">Category Name</td>
                            <td>{productDetails?.category?.name}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Class Type</td>
                            <td>{productDetails?.classType}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">New Badge</td>
                            <td style={{ color: productDetails?.isNewProduct ? 'green' : 'red' }}>
                              {productDetails?.isNewProduct ? 'ENABLED' : 'DISABLED'}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Outlet Type</td>
                            <td className="text-primary">
                              {productDetails?.isEventProduct ? 'For Event Outlet' : 'For Regular Outlet'}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Freebie Product</td>
                            <td className="text-primary">
                              {productDetails?.isFreebieProduct ? 'YES' : 'NO'}
                            </td>
                          </tr>
                          {productDetails?.orderType ? (
                            <tr>
                              <td className="fw-semibold bg-light">Order Type</td>
                              <td style={{ color: productDetails?.orderType === "ALL" ? 'blueviolet' : productDetails?.orderType === "DELIVERY" ? 'green' : 'orangered' }}>
                                {productDetails?.orderType}
                              </td>
                            </tr>
                          ) : null}
                          {productDetails?.deliveryMakingTime ? (
                            <tr>
                              <td className="fw-semibold bg-light">Del Making Time</td>
                              <td>
                                {productDetails?.deliveryMakingTime}
                              </td>
                            </tr>
                          ) : null}
                          {productDetails?.makingTime ? (
                            <tr>
                              <td className="fw-semibold bg-light">Making Time</td>
                              <td>
                                {productDetails?.makingTime}
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </Table>

                      {/* Product Details Table */}
                      <Table bordered hover>
                        <tbody>
                          <tr>
                            <td className="fw-semibold bg-light w-25">Tax Percent</td>
                            <td>{productDetails?.taxPercent} %</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light w-25">Calories</td>
                            <td>{productDetails?.calories}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Weight</td>
                            <td>{productDetails?.weight}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Weight Units</td>
                            <td>{productDetails?.weightUnit}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Product Costing</td>
                            <td>{productDetails?.productCost ? `₹. ${productDetails?.productCost}` : "Not Mentioned"}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">MRP</td>
                            <td>₹. {productDetails?.mrp || 0}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Offer Price</td>
                            <td>₹. {productDetails?.offerPrice || 0}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">Product's Nature</td>
                            <td>
                              {productDetails?.productsNature?.length > 0
                                ? productDetails.productsNature.map((outlet) => outlet.toLowerCase().trim()).join(', ')
                                : 'Not Available'}
                            </td>
                          </tr>
                        </tbody>
                      </Table>

                      <Table bordered hover>
                        <tbody>
                          <tr>
                            <td className="fw-semibold bg-light w-25">Keywords</td>
                            <td>{productDetails?.keywords}</td>
                          </tr>
                          <tr>
                            <td className="fw-semibold bg-light">HSN</td>
                            <td>{productDetails?.hsn}</td>
                          </tr>
                        </tbody>
                      </Table>

                    </Col>
                  </Row>
                </div>
              </Modal.Body>
              <Modal.Footer className="border-top-0">
                {/* <ReactToPrint
                  trigger={() => (
                    <Button variant="primary" style={{ borderRadius: '20px' }}>
                      Print Details
                    </Button>
                  )}
                  content={() => printRef.current}
                /> */}
                <Button variant="primary" onClick={handlePrint}>
                  Print Details
                </Button>
                <Button variant="secondary" onClick={() => setOpenViewModal(false)}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          ) : null}

        </div>
      </div>
      {/* CSS Animation Styles */}
      <style>
        {`
          @keyframes skeletonPulse {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default MenuCatalog;